module.exports = __webpack_public_path__ + "img/qingsu-share-poster.70e0d00c.png";